<template>
  <div class="_content">
    <div class="head-img">
      <img :src="shopHeadImg" class="shop_door_img" alt="店铺门头照" />
      <div class="switch-img">
        <div
          class="switch"
          v-upload="{ onUpload: upload, index: 999, refresh: true }"
        >
          更换
        </div>
      </div>
    </div>

    <div class="shop_bar">
      <!-- 营业状态 -->
      <div>
        <van-cell center title="营业状态">
          <van-switch
            :value="checked"
            @click="onInput1"
            active-color="#33cc33"
            inactive-color="#ccc"
          />
        </van-cell>
      </div>
      <!-- 营业时间 -->
      <div>
        <!-- 输入框 -->
        <van-field
          readonly
          clickable
          label="营业时间"
          :value="workTime"
          :placeholder="
            `${shopStatusData.openingTime}-${shopStatusData.closingTime} `
          "
          @click="showPicker = true"
          input-align="right"
          is-link
        />

        <van-popup v-model="showPicker" round position="bottom">
          <!-- 选择器 -->
          <van-picker
            show-toolbar
            title="营业时间"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </div>

      <shop-info  v-show="!showEdit"
        :_shopBasicData="shopBasicData"
        :_shopMerchantData="shopMerchantData"
        :_shopCompanyData="shopCompanyData"
        :_CertificatePhotoData="CertificatePhotoData"
        :_showTab="active"
        @changeTabInfo="changeTabInfo"
      />

      <div class="edit-shop-info" v-show="showEdit">
        <shop-info
          ref="shopInfoRef"
          :isEdit="showEdit"
          :_shopBasicData="shopBasicData"
          :_shopMerchantData="shopMerchantData"
          :_shopCompanyData="shopCompanyData"
          :_CertificatePhotoData="CertificatePhotoData"
          :_showTab="active"
          @hide="showEdit = false"
        />
      </div>

      <div>
        <van-button
          class="shop_info_btn"
          size="large"
          color="rgb(25,137,250)"
          plain
          type="info"
          :hairline="true"
          @click="showTabs"
          >修改</van-button
        >
      </div>
    </div>

    <!--  -->
    <van-dialog
      v-model="visibleShop"
      :showConfirmButton="false"
      class="shopCustoremClass"
    >
      <!-- <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" /> -->
      <p class="title">门店营业状态变更</p>
      <p class="text">如需更改门店营业状态，请联系市场经理或致电客服</p>
      <div class="btn">
        <p @click="visibleShop = false">取消变更</p>
        <p v-call>联系客服</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import config from "@/configs/config";
import { localStorage } from "@/commons/storage";
import { Dialog } from "vant";
import shopInfo from "@/components/shopInfo";
import defaultImg from "@/imgs/image/defaultShopImg.png";

const urlTypes = [
  {
    urlType: "business_license",
    imgUrl: "",
    name: "营业执照"
  },
  {
    urlType: "working_area",
    imgUrl: "",
    name: "工位图"
  },
  {
    urlType: "rest_area",
    imgUrl: "",
    name: "休息区"
  },
  {
    urlType: "other",
    imgUrl: "",
    name: "其他形象图"
  }
];

function getRange(all) {
  var arr = [];
  let c = all === 24 ? "时" : "分";
  for (let i = 0; i < all; i++) {
    if (i < 10) {
      arr.push("0" + i + c);
    } else {
      arr.push(i + c);
    }
  }
  return arr;
}
const hours = getRange(24);

export default {
  components: {
    shopInfo
  },
  data() {
    return {
      visibleShop: false,
      defaultImg,
      shopHeadImg: "",
      shopStatusData: {}, // 营业状态
      shopBasicData: {}, // 基本信息
      shopMerchantData: {}, // 店铺信息
      shopCompanyData: {}, // 企业信息
      CertificatePhotoData: urlTypes, // 证照店照
      checked: true,
      workTime: "", // 营业时间
      workStartTime: "", // 营业开始时间
      workEndTime: "", // 营业结束时间
      showPicker: false,
      showPicker2: false,
      columns: [
        // 第一列
        {
          values: hours,
          defaultIndex: 2
        },
        // 第二列
        {
          values: ["00分", "30分"],
          defaultIndex: 1
        },
        // 第三列
        {
          values: ["-"],
          defaultIndex: 1
        },
        // 第4列
        {
          values: hours,
          defaultIndex: 1
        },
        // 第5列
        {
          values: ["00分", "30分"],
          defaultIndex: 1
        }
      ],
      active: 0, // 当前第几个tab
      showEdit: false,
      title: "",
      tabList1: [
        {
          name: "员工权限",
          url: "/pages/changeShopInfo/index"
        }
      ]
    };
  },
  created() {
    this.getShopInfo();
    this.getShopBasicInfo();
    this.getMerchantInfo();
    this.getCompanyInfo();
    this.getCertificatePhoto();
    this.ShowTab();
  },
  // mounted() {
  // 	if (window.history && window.history.pushState) {
  //     // 向历史记录中插入了当前页
  //     // history.pushState(null, null, document.URL)
  //     window.addEventListener('popstate', this.goBack, false)
  // 	}
  // },
  // destroyed () {
  // 	window.removeEventListener('popstate', this.goBack, false)
  // },
  computed: {
    shopInfo() {
      return tuhu.store.state.currentShopInfo;
    },
    shopId() {
      return this.shopInfo ? this.shopInfo.shopId : tuhu.getParam("shopId");
    }
  },
  methods: {
    // goBack () {
    // 	console.log('点击了浏览器的返回按钮')
    // 	window.location.href = '/pages/home/index'
    // },
    ShowTab() {
      if (localStorage.get("shopinfo_showtab")) {
        this.active = localStorage.get("shopinfo_showtab");
      }
    },
    // 修改按钮
    showTabs() {
      this.showEdit = true;
      this.active = this.active + 1;
      setTimeout(() => {
        this.active = this.active - 1;
      }, 0);
    },
    // 子元素当前tab数
    changeTabInfo(i) {
      this.active = i;
    },
    upload(val) {
      if (val && val.code === '200' && val.data) {
        this.shopHeadImg = val.data;
        this.changeShopDoorImg(val.data);
      }
    },
    async changeShopDoorImg(url) {
      try {
        const data = await tuhu.fetch(`${config.apis.GET_DOOR_URL}`, {
          method: "post",
          body: JSON.stringify({
            shopId: this.shopId,
            url: url
          })
        });
        if (data && data.code === '200') {
          tuhu.toast("门头照片更换成功");
        } else {
          tuhu.toast(data.message || "网络错误");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getShopInfo() {
      // 营业状态
      const data = await tuhu.fetch(`${config.apis.SHOP_OPEN_INFO}`, {
        method: "post",
        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data && data.code === '200') {
        this.shopStatusData = data.data;
        this.shopHeadImg = data.data.doorPhoto || defaultImg;
        // 门店状态
        if (data.data.shopStatus === 1) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async getShopBasicInfo() {
      // 基本信息
      const data = await tuhu.fetch(`${config.apis.SHOP_BASIC_INFO}`, {
        method: "post",
        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data && data.code === '200') {
        this.shopBasicData = data.data;
        // console.log('this.shopBasicData', this.shopBasicData)
        this.$nextTick(() => {
          this.renderShopMap(data.data);
        });
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    renderShopMap(info) {
      const data = {
        lat: info.shopLatitude || 31.1364283468,
        lng: info.shopLongitude || 121.3640087132,
        name: info.shopName || "小鲲车服测试门店",
        address: info.shopAddress || "上海市徐汇区罗秀路105号（近平福路路口）"
      };
      this.$refs.shopInfoRef.initMap(data)
      // window._locateToData = data;
      // let src = "/static/locateline.html?isLocate=1";
      // if (location.host.indexOf("47.99.172.20") > -1) {
      //   // src = 'https://www.xiaokunkeji.cn/user/vue/locateline.html?isLocate=1'
      //   src = `${config.apis.RENDER_MAP}`;
      // }
      // const iframe = $(
      //   `<iframe width="100%" height="100%" frameborder="0" src="${src}"></iframe>`
      // );
      // $("#shop-map").empty();
      // $("#shop-map").append(iframe);
    },
    async getMerchantInfo() {
      // 店铺信息
      const data = await tuhu.fetch(`${config.apis.SHOP_MERCHANT_INFO}`, {
        method: "post",
        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data && data.code === '200') {
        this.shopMerchantData = data.data;
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async getCompanyInfo() {
      // 企业信息
      const data = await tuhu.fetch(`${config.apis.SHOP_COMPANY_INFO}`, {
        method: "post",
        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data && data.code === '200') {
        this.shopCompanyData = data.data;
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async getCertificatePhoto() {
      // 证照店照
      const data = await tuhu.fetch(`${config.apis.SHOP_CERTIFICATE_PHOTO}`, {
        method: "post",
        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data && data.code === '200') {
        const arr = data.data || [];
        arr.forEach(item => {
          item["name"] =
            item.urlType === urlTypes[0].urlType
              ? urlTypes[0].name
              : item.urlType === urlTypes[1].urlType
              ? urlTypes[1].name
              : item.urlType === urlTypes[2].urlType
              ? urlTypes[2].name
              : item.urlType === urlTypes[3].urlType
              ? urlTypes[3].name
              : "";
        });
        this.CertificatePhotoData = arr;
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async onConfirm(value) {
      this.workTime = value
        .toString()
        .replace(/,/g, "")
        .replace("时", ":")
        .replace("时", ":")
        .replace("分", "")
        .replace("分", "");
      this.showPicker = false;
      this.showPicker2 = true;
      let Time = this.workTime.split("-");
      this.workStartTime = Time[0];
      this.workEndTime = Time[1];
      const { shopId, workStartTime, workEndTime } = this;
      const data = await tuhu.fetch(
        `${config.apis.GET_BUSINESS_HOURS}?shopId=${shopId}&openingTime=${workStartTime}&closingTime=${workEndTime}`
      );
      if (data && data.code === '200') {
        tuhu.toast("设置成功");
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async onInput1() {
      this.visibleShop=true
      // let checked = this.checked;
      // if (checked) {
      //   this.visibleShop = true;
      // } else {
      //   const data = await tuhu.fetch(
      //     `${config.apis.GET_SHOP_STATUS}?shopId=${this.shopId}&shopStatus=${
      //       this.checked ? 0 : 1
      //     }`
      //   );
      //   if (data && data.code === '200') {
      //     tuhu.toast("修改门店营业状态成功");
      //     console.log("原本3", this.checked);
      //     console.log("原本4", checked);
      //     // tuhu.store.commit('setCurrentShopInfo', Object.assign(this.shopInfo, { shopStatus: this.checked ? 0 : 0 }))
      //     // window.pagesHomeVUe.setShopStatus(this.checked ? 1 : 0)
      //     this.checked = !checked;
      //   }
      // }
    }
  }
};
</script>
<style lang="less">
.shop_info_btn {
  .van-button__text {
    color: rgb(25, 137, 250);
  }
}
</style>
<style lang="less" scoped>
._content {
  background: #f4f4f4;
}
.head-img {
  width: 100%;
  height: 10rem;
  position: relative;
  .shop_door_img {
    width: 100%;
    height: 10rem;
  }
  .switch-img {
    position: absolute;
    width: 100%;
    height: 1.8rem;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0.5rem;
    .switch {
      display: inline-block;
      width: 3rem;
      height: 1.2rem;
      line-height: 1.2rem;
      text-align: center;
      background: rgba(0, 110, 239, 1);
      color: #fff;
      border-radius: 4px;
    }
  }
}
.shop_bar {
  width: 100%;
  // height: 5rem;
  display: flex;
  flex-direction: column;
  > div {
    display: flex;
    justify-content: center;
  }
}
.edit-shop-info {
  background: #f4f4f4;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;
  text-align: center;
}

.shopCustoremClass {
  border-radius: 0.5rem;
  .title {
    text-align: center;
    font-size: 0.9rem;
    color: #333;
    font-weight: 500;
    margin-top: 1rem;
  }
  .text {
    margin-top: 0.8rem;
    line-height: 1rem;
    padding: 0 1rem;
    font-size: 0.75rem;
    color: #333;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 1rem;
    p {
      height: 2.2rem;
      line-height: 2.2rem;
      text-align: center;
      width: 50%;
      border-top: 1px solid #e5e5e5;
    }
    p:nth-child(1) {
      color: #999;
      border-right: 1px solid #e5e5e5;
    }
    p:nth-child(2) {
      color: #1677ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shopInfo/index.vue